export default __webpack_public_path__ + "c1791ace2adbca4163cab1071d66ab3e.woff2";